import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2180a04b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-4" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "section-title-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Customer reviews", -1))
const _hoisted_6 = { class: "box-score" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-text" }, [
  /*#__PURE__*/_createTextVNode(" Average Review "),
  /*#__PURE__*/_createElementVNode("span", { class: "score" }, "4.0")
], -1))
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "comment-header" }
const _hoisted_10 = { class: "user-name" }
const _hoisted_11 = { class: "comment-body" }
const _hoisted_12 = { class: "comment-title" }
const _hoisted_13 = { class: "comment-content" }
const _hoisted_14 = { class: "comment-pagination" }
const _hoisted_15 = { class: "dialog-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "variant-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://via.placeholder.com/100",
    class: "cover"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title text-overflow" }, " Break Room Separation - Zero Waste Box™ Break Room Separation - Zero Waste Box™ Break Room Separation - Zero Waste Box™ "),
    /*#__PURE__*/_createElementVNode("div", { class: "option-value" }, " CS33-L Size: Large Zero Waste Box 15\" x 15\" x 37\", SAP Item Number: 510-1003 ")
  ])
], -1))
const _hoisted_17 = { class: "form-box" }

import { ref, reactive, computed } from 'vue';
  import _ from 'lodash';
  import { FormItem } from '@/types/form';

  interface IForm {
    score: number;
    content: string;
    title: string;
    name: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const defaultFrom = {
    score: 0,
    content: '',
    title: '',
    name: '',
  };

  const comments = [
    {
      score: 4,
      name: 'Joe Josephs',
      date: '2021-05-11',
      title: 'Every day items',
      content: 'I bought the small box and it took me a long time to fill and its perfect for everyday items around the house.'
    },
    {
      score: 4,
      name: 'Joe Josephs',
      date: '2021-05-11',
      title: 'Every day items',
      content: 'I bought the small box and it took me a long time to fill and its perfect for everyday items around the house.'
    }
  ];

  const form = reactive<IForm>(_.cloneDeep(defaultFrom));

  const formConfigs = computed<FormItem[]>(() => {
    return [
      {
        label: 'Content',
        type: 'textarea',
        required: true,
        key: 'content',
        inputType: 'text',
      },
      {
        label: 'Title',
        type: 'input',
        required: true,
        key: 'title',
        inputType: 'text',
      },
      {
        label: 'Your Name',
        type: 'input',
        required: true,
        key: 'name',
        inputType: 'text',
      },
    ];
  });

  const showCommentDialog = ref<boolean>(false);

  function handleCommentDialogShow() {
    showCommentDialog.value = true;
  }

  function handleCommentDialogClose() {
    showCommentDialog.value = false;
  }

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  function handleFormSubmit() {
    // TODO: 对接 api
    handleCommentDialogClose();
  }

return (_ctx: any,_cache: any) => {
  const _component_AppScore = _resolveComponent("AppScore")!
  const _component_AppPagination = _resolveComponent("AppPagination")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_AppScore, { score: 4 }),
            _hoisted_7,
            _createElementVNode("div", {
              class: "comment-create-btn",
              onClick: handleCommentDialogShow
            }, " Log in to leave a review ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(comments, (comment, commentIndex) => {
        return _createElementVNode("div", {
          key: commentIndex,
          class: "box-comment"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_AppScore, {
              score: comment.score
            }, null, 8, ["score"]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(comment.name) + " • " + _toDisplayString(comment.date), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(comment.title), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(comment.content), 1)
          ])
        ])
      }), 64)),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_AppPagination, {
          total: 10,
          "per-page": 2,
          page: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_AppDialog, {
        visible: showCommentDialog.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showCommentDialog).value = $event)),
        title: "Write a Review",
        "btn-text": "Submit your review",
        onConfirm: handleFormSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_b_form_group, {
                label: "Rating",
                "label-class": ['group-item-label', { required: true }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppScore, {
                    score: _unref(form).score,
                    "onUpdate:score": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).score) = $event)),
                    editable: ""
                  }, null, 8, ["score"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formConfigs), (item) => {
                return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
                  key: item.key,
                  form: _unref(form),
                  config: item,
                  onChange: formItemChange
                }, null, 8, ["form", "config"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]))
  ]))
}
}

})